module.exports = __webpack_public_path__ + "static/video-32c4f955674f2fe459afc3d136add9ff.png";